import React, { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
// import axios from "axios"; // or your preferred HTTP client
import "./auth.css";
import RegisterStep from "../../components/auth/RegisterStep";
import TradeReferences from "./TradeReferences";
import { useDispatch, useSelector } from "react-redux";
import { validateTags } from "../../store/slices/tagInputSlice";
import { useRegisterMutation } from "../../store/api/authApi";
import InlineLoaderComponent from "../../components/common/InlineLoaderComponent";
import { useNavigate } from "react-router-dom";
import InlineMessageComponent from "../../components/common/InlineMessageComponent";
import IcClose from "../../assets/icons/IcClose";
import {
  useGetCountryListQuery,
  useGetStateListQuery,
} from "../../store/api/profileApi";
import { openRegisterModel } from "../../store/slices/commonSlice";
import BannerHeader from "../../components/BannerHeader/BannerHeader";
import styles from "./signup.module.css";
import privacyStyles from "../../pages/PrivacyPolicy.module.css";

const Signup = () => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // or "onChange" or "all"
    reValidateMode: "onChange",
    defaultValues: {
      tradeReference: [{}, {}, {}], // start with 3
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "tradeReference",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tagInputState = useSelector((state) => state.tagInput);

  const [compatedStep, setComplatedStep] = useState(1);
  const [submitStep, setSubmitStep] = useState(0);
  const tagKeys = ["companyName", "personName", "personEmail", "contactNumber"];
  const [
    onRegister,
    {
      isLoading: registrationInProgress,
      data: registerData,
      error: errorInRegister,
    },
  ] = useRegisterMutation();
  const { data: countryList } = useGetCountryListQuery();
  const password = watch("password");
  const country = watch("country");
  const whitlistCountriesForStateApi = ["USA", "Canada", "India"];
  const selctedCountry = whitlistCountriesForStateApi?.includes(country)
    ? countryList?.find((item) => item.name === country)
    : null;
  const { data: stateList } = useGetStateListQuery(selctedCountry?.id, {
    skip: !selctedCountry,
  });
  //   {
  //     "isError": false,
  //     "message": "Account created successfully!"
  // }
  // const fileToBinary = (file) => {
  //   return new Promise((resolve, reject) => {
  //     if (!(file instanceof Blob)) {
  //       // Check if it's a valid file
  //       reject(new Error("Invalid file object"));
  //       return;
  //     }

  //     const reader = new FileReader();

  //     reader.onload = (e) => {
  //       const bytes = new Uint8Array(e.target.result);
  //       let binaryString = "";
  //       for (const byte of bytes) {
  //         binaryString += byte.toString(2).padStart(8, "0");
  //       }
  //       resolve(binaryString);
  //     };

  //     reader.onerror = () => reject(new Error("Failed to read file"));
  //     reader.readAsArrayBuffer(file); // Must receive a Blob/File
  //   });
  // };
  const onSubmit = async (formData) => {
    let data = formData;
    delete formData.confirmPassword;
    formData.govId = formData.govId[0];
    formData.bizLicense = formData.bizLicense[0];
    delete formData.companyName;
    if (data && submitStep === 0) {
      setComplatedStep(compatedStep + 1);
      setSubmitStep(submitStep + 1);
    } else if (submitStep === 1) {
      let isFormValid = true;
      if (data.tradeReference.length < 3) {
        setError("tradeReference", {
          type: "manual",
          message: "At least 3 trade references are required.",
        });
        isFormValid = false;
        return;
      } else {
        isFormValid = true;
      }
      if (isFormValid) {
        setComplatedStep(compatedStep + 1);
        setSubmitStep(submitStep + 1);
      }
      {
      }
    } else {
      onRegister({
        ...data,
        tradeReference: JSON.stringify(formData?.tradeReference),
      })
        .unwrap()
        .then(() => {
          dispatch(openRegisterModel(true));
          navigate("/");
        })
        .catch();
    }
  };

  // Sample options for select fields
  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"];
  const states = ["California", "Texas", "Florida", "New York", "Illinois"];
  const countries = ["United States", "Canada", "United Kingdom", "Australia"];

  const handlePrevious = () => {
    setComplatedStep(compatedStep - 1);
    setSubmitStep(submitStep - 1);
  };

  return (
    <div className={styles.mainContainer}>
      <BannerHeader />

      <section className={"container"}>
        <div className={styles.contactUsHeader}>
          <h1 className="heading">Credit Application</h1>
          <p className="subheading">Please tell us about your business.</p>
        </div>
        {/* Business Information */}
        <RegisterStep compatedStep={compatedStep} />
        <div className={styles.signUpBox + " login-registration-container"}>
          <InlineMessageComponent
            type={"error"}
            message={errorInRegister?.data?.message}
          />

          <form
            onSubmit={handleSubmit(onSubmit)}
            encType="multipart/form-data"
            className="signup-login-form"
          >
            {compatedStep === 1 && (
              <div>
                <div className={styles.registrationPara}>
                  <div className={styles.title}>
                    Dear Customer and Business Partner:
                  </div>
                  <div className={styles.subTitle}>
                    I am writing to you to inquire whether you have instituted
                    an anti-money laundering (AML) program in compliance with
                    the USA PATRIOT Act, the U.S. Bank Secrecy act and other
                    regulatory requirements.In order to complete our compliance
                    obligation, we are required under our policy and program to
                    acquire the following identifying information for all our
                    business partners and customers. Please provide the
                    following identifying information.
                  </div>
                </div>
                <div className="form-group radio-group">
                  {/* <label className="form-label">Do you have an AML program?*</label> */}

                  <div className="form-radio-option">
                    <input
                      type="radio"
                      id="amlYes"
                      value="true"
                      {...register("isHaveAmlProgram", {
                        required: "This field is required",
                      })}
                    />
                    <label
                      style={{
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                        letterSpacing: "0.01rem",
                      }}
                      htmlFor="amlYes"
                    >
                      Yes, we have or will be instituting an AML Program.
                    </label>
                  </div>

                  <div className="form-radio-option">
                    <input
                      type="radio"
                      id="amlNo"
                      value="false"
                      {...register("isHaveAmlProgram", {
                        required: "This field is required",
                      })}
                    />
                    <label
                      htmlFor="amlNo"
                      style={{
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                        letterSpacing: "0.01rem",
                      }}
                    >
                      No, we will not institute an AML program due to our status
                      as an "exempt" retailer.
                    </label>
                  </div>

                  {errors.isHaveAmlProgram && (
                    <span className="error-message">
                      {errors.isHaveAmlProgram.message}
                    </span>
                  )}
                </div>

                <div className="group-container">
                  <div className="form-group">
                    <label>Business Name*</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("businessName", {
                        required: "Business name is required",
                      })}
                    />
                    {errors.businessName && (
                      <span className="error-message">
                        {errors.businessName.message}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>DBA Name</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("dbaName")}
                    />
                  </div>
                </div>
                <div className="group-container">
                  <div className="form-group">
                    <label>Owner Name</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("ownerName")}
                    />
                  </div>

                  <div className="form-group">
                    <label>Owner Phone</label>
                    <input
                      className="form-input"
                      type="tel"
                      {...register("ownerPhone", {
                        pattern: {
                          value:
                            /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                          message: "Invalid phone number",
                        },
                      })}
                    />
                    {errors.ownerPhone && (
                      <span className="error-message">
                        {errors.ownerPhone.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Owner Email</label>
                    <input
                      className="form-input"
                      type="email"
                      {...register("ownerEmail", {
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      })}
                    />
                    {errors.ownerEmail && (
                      <span className="error-message">
                        {errors.ownerEmail.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label>User Email*</label>
                  <input
                    className="form-input"
                    type="email"
                    {...register("userEmail", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.userEmail && (
                    <span className="error-message">
                      {errors.userEmail.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Password*</label>
                  <input
                    className="form-password"
                    type="password"
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters",
                      },
                    })}
                  />
                  {errors.password && (
                    <span className="error-message">
                      {errors.password.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Confirm Password*</label>
                  <input
                    className="form-password"
                    type="password"
                    {...register("confirmPassword", {
                      required: "Please confirm your password",
                      validate: (value) =>
                        value === password || "Passwords do not match",
                    })}
                  />
                  {errors.confirmPassword && (
                    <span className="error-message">
                      {errors.confirmPassword.message}
                    </span>
                  )}
                </div>

                {/* Contact Information */}

                <div className="group-container">
                  <div className="form-group">
                    <label>Accounting Contact Name</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("accountingContactName")}
                    />
                  </div>

                  <div className="form-group">
                    <label>Email*</label>
                    <input
                      className="form-input"
                      type="email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <span className="error-message">
                        {errors.email.message}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Phone</label>
                    <input
                      className="form-input"
                      type="tel"
                      {...register("phone", {
                        pattern: {
                          value:
                            /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                          message: "Invalid phone number",
                        },
                      })}
                    />
                    {errors.phone && (
                      <span className="error-message">
                        {errors.phone.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="group-container">
                  <div className="form-group">
                    <label>Address Line 1*</label>
                    <textarea
                      className="form-textarea"
                      {...register("address", {
                        required: "Address is required",
                      })}
                    />
                    {errors.address && (
                      <span className="error-message">
                        {errors.address.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Address Line 2*</label>
                    <textarea
                      className="form-textarea"
                      {...register("secondaryAddress")}
                    />
                    {errors.secondaryAddress && (
                      <span className="error-message">
                        {errors.secondaryAddress.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className="group-container-grid">
                  <div className="form-group">
                    <label>Building Name</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("buildingName")}
                    />
                    {errors.buildingName && (
                      <span className="error-message">
                        {errors.buildingName.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>City*</label>

                    <input
                      className="form-input"
                      type="text"
                      {...register("city", {
                        required: "City is required",
                      })}
                    />
                    {errors.city && (
                      <span className="error-message">
                        {errors.city.message}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Country*</label>
                    <select
                      className="form-select"
                      {...register("country", {
                        required: "Country is required",
                      })}
                    >
                      <option value="">Select Country</option>
                      {countryList?.map((icountry) => (
                        <option key={icountry.name} value={icountry.name}>
                          {icountry.name}
                        </option>
                      ))}
                    </select>
                    {errors.country && (
                      <span className="error-message">
                        {errors.country.message}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>State*</label>
                    {selctedCountry ? (
                      <select
                        className="form-select"
                        {...register("state", {
                          required: "State is required",
                        })}
                      >
                        <option value="">Select State</option>
                        {stateList?.map((istate) => (
                          <option key={istate?.name} value={istate?.name}>
                            {istate?.name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        className="form-input"
                        type="text"
                        {...register("state", {
                          required: "State is required",
                        })}
                      />
                    )}
                    {errors.state && (
                      <span className="error-message">
                        {errors.state.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Postal Code*</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("postalCode", {
                        required: "Postal code is required",
                      })}
                    />
                    {errors.postalCode && (
                      <span className="error-message">
                        {errors.postalCode.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Fax</label>
                    <input
                      className="form-input"
                      type="tel"
                      {...register("fax", {
                        pattern: {
                          value:
                            /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                          message: "Invalid fax number",
                        },
                      })}
                    />
                    {errors.fax && (
                      <span className="error-message">
                        {errors.fax.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Website URL</label>
                    <input
                      className="form-input"
                      type="url"
                      {...register("websiteUrl", {
                        pattern: {
                          value:
                            /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
                          message: "Invalid URL",
                        },
                      })}
                    />
                    {errors.websiteUrl && (
                      <span className="error-message">
                        {errors.websiteUrl.message}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>TIN/GST Number*</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("tinGstNumber", {
                        required: "TIN/GST Number is required",
                      })}
                    />
                    {errors.tinGstNumber && (
                      <span className="error-message">
                        {errors.tinGstNumber.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Resale Certificate Number*</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("resaleCertificateNumber", {
                        required: "Resale Certificate Number is required",
                      })}
                    />
                    {errors.resaleCertificateNumber && (
                      <span className="error-message">
                        {errors.resaleCertificateNumber.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Government License Number</label>
                    <input
                      className="form-input"
                      type="text"
                      {...register("govLicenseNumber")}
                    />
                  </div>

                  {/* <div className="form-group">
                <label>Trade Reference</label>
                <input
                  className="form-input"
                  type="text"
                  {...register("tradeReference")}
                />
              </div> */}
                </div>

                <div className="form-group">
                  <label>Government ID*</label>
                  <input
                    className="form-file-upload"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    {...register("govId", {
                      required: "Government ID is required",
                      validate: {
                        fileSize: (fileList) => {
                          const file = fileList?.[0];
                          const maxSizeInBytes = 20 * 1024 * 1024; // 20 MB
                          return (
                            (file && file.size <= maxSizeInBytes) ||
                            "File must be less than 20 MB"
                          );
                        },
                      },
                    })}
                  />
                  <div
                    className="file-types-note"
                    style={{ fontSize: "0.98rem", color: "#666", marginTop: 4 }}
                  >
                    Accepted file types: jpg, gif, png, pdf, Max. file size: 20
                    MB.
                  </div>
                  {errors.govId && (
                    <span className="error-message">
                      {errors.govId.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label>Business License*</label>
                  <input
                    className="form-file-upload"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    {...register("bizLicense", {
                      required: "Business license is required",
                      validate: {
                        fileSize: (fileList) => {
                          const file = fileList?.[0];
                          const maxSizeInBytes = 20 * 1024 * 1024; // 20 MB
                          return (
                            (file && file.size <= maxSizeInBytes) ||
                            "File must be less than 20 MB"
                          );
                        },
                      },
                    })}
                  />
                  <div
                    className="file-types-note"
                    style={{ fontSize: "0.98rem", color: "#666", marginTop: 4 }}
                  >
                    Accepted file types: jpg, gif, png, pdf, Max. file size: 20
                    MB.
                  </div>
                  {errors.bizLicense && (
                    <span className="error-message">
                      {errors.bizLicense.message}
                    </span>
                  )}
                </div>
              </div>
            )}
            {compatedStep === 2 && (
              <>
                <div className="d-flex justify-content-end my-3">
                  <button
                    type="button"
                    onClick={() =>
                      append({
                        companyName: "",
                        personName: "",
                        personEmail: "",
                        contactNumber: "",
                      })
                    }
                    className="submit-button"
                  >
                    Add Reference
                  </button>
                </div>{" "}
                {fields.map((item, index) => (
                  <div
                    key={item.id}
                    className="d-flex gap-2 align-items-center field-array-item"
                  >
                    <div className="form-group">
                      <label>Company Name</label>
                      <input
                        {...register(`tradeReference.${index}.companyName`, {
                          required: "Company Name is required",
                        })}
                        className="form-input"
                      />
                      {errors.tradeReference?.[index]?.companyName && (
                        <span className="error-message">
                          {errors.tradeReference[index].companyName.message}
                        </span>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Person Name</label>
                      <input
                        {...register(`tradeReference.${index}.personName`, {
                          required: "Person Name is required",
                        })}
                        className="form-input"
                      />
                      {errors.tradeReference?.[index]?.personName && (
                        <span className="error-message">
                          {errors.tradeReference[index].personName.message}
                        </span>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Person Email</label>
                      <input
                        {...register(`tradeReference.${index}.personEmail`, {
                          required: "Person Email is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                        className="form-input"
                      />
                      {errors.tradeReference?.[index]?.personEmail && (
                        <span className="error-message">
                          {errors.tradeReference[index].personEmail.message}
                        </span>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Contact Number</label>
                      <input
                        {...register(`tradeReference.${index}.contactNumber`, {
                          required: "Contact Number is required",
                          pattern: {
                            value:
                              /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                            message: "Invalid contact number",
                          },
                        })}
                        className="form-input"
                        type="tel"
                      />
                      {errors.tradeReference?.[index]?.contactNumber && (
                        <span className="error-message">
                          {errors.tradeReference[index].contactNumber.message}
                        </span>
                      )}
                    </div>

                    <div onClick={() => remove(index)} className="close-icon">
                      <IcClose />
                    </div>
                  </div>
                ))}
                {errors.tradeReference && (
                  <span className="error-message mb-3">
                    {errors.tradeReference.message}
                  </span>
                )}
              </>
            )}
            {compatedStep === 3 && (
              <div className="terms-step my-3">
                <div
                  style={{
                    maxHeight: 320,
                    overflowY: "auto",
                    background: "#fff",
                    border: "1px solid #eee",
                    borderRadius: 8,
                    padding: "18px 20px",
                    marginBottom: 18,
                    fontSize: "1.02rem",
                    color: "#333",
                    lineHeight: 1.7,
                  }}
                >
                  <h2>Terms and Conditions</h2>
                  <p>
                    These terms and conditions apply to the Greenrock Creations
                    website and its subsidiaries and affiliates (collectively
                    the "Site") and other websites that expressly incorporate
                    these Conditions ("Conditions"). In some instances, a
                    particular Greenrock Creations product purchased through the
                    Site may be subject to additional policies, guidelines,
                    terms, and/or agreements ("Terms"). In the event that such
                    Terms are inconsistent with these Conditions, the Terms
                    shall govern. BY VISITING AND/OR USING THIS SITE IN ANY WAY,
                    SUCH AS BROWSING PRODUCTS OR PLACING AN ORDER, YOU AGREE TO
                    THESE TERMS AND CONDITIONS. Please read these Conditions
                    carefully. If you do not wish to be bound by these
                    Conditions, do not access or use the Greenrock Creations
                    Site.
                  </p>
                  <h3>Change of Terms</h3>
                  <p>
                    Greenrock Creations may, at its sole discretion, revise or
                    add new terms to these Conditions from time to time without
                    notice to you. Such revisions and additions shall be deemed
                    effective immediately upon notice, which Greenrock Creations
                    may give by any means, including, without limitation, by
                    posting the revised Conditions on the Greenrock Creations
                    Site. You are responsible for reviewing the Greenrock
                    Creations Site for any modifications to these Conditions
                    that may affect your rights or obligations. Any change or
                    modification will be effective immediately upon posting of
                    the revisions on the Site. Any access or use by you of the
                    Greenrock Creations Site after changes to these Conditions
                    will constitute your acceptance of the revised terms. If you
                    do not agree to the amended terms, you must stop using the
                    Site.
                  </p>
                  <h3>Content</h3>
                  <p>
                    The Site and all content and other materials, including,
                    without limitation, text, icons, graphics, logos, images,
                    designs, pictures, selection, coordination, "look and feel",
                    information, data, sound files, and other files and software
                    is the proprietary property of Greenrock Creations or its
                    affiliates, licensors or users and is protected by United
                    States and international trade dress, copyright laws, patent
                    and trademark laws, and various other intellectual property
                    rights and unfair competition laws. Copyright in the
                    documents and material on the Greenrock Creations Site is
                    owned by or licensed to Greenrock Creations. You are
                    authorized to use this material only for personal,
                    non-commercial purposes. You may download, print, and store
                    copies of this material for your own personal,
                    non-commercial use. Nothing contained on the Greenrock
                    Creations Site should be construed as granting, by
                    implication or otherwise, any license or right to use any
                    trademark or service mark displayed on the Greenrock
                    Creations Site without the written permission of Greenrock
                    Creations or any third party that may own such trademarks or
                    service marks. Greenrock Creations will aggressively enforce
                    its intellectual property rights to the fullest extent of
                    the law.
                  </p>
                  <h3>Trademarks</h3>
                  <p>
                    Greenrock Creations, the Greenrock Creations logos, and any
                    other product or service name or slogan contained in our
                    Site are trademarks of Greenrock Creations and/or its
                    licensors, and may not be copied, imitated or used, in whole
                    or in part, without the prior written permission of
                    Greenrock Creations or the applicable trademark holder. You
                    may not use any metatags or any other "hidden text"
                    utilizing "Greenrock Creations" or any other name, trademark
                    or product or service name of Greenrock Creations without
                    our prior written permission. All other trademarks,
                    registered trademarks, product names and Greenrock Creations
                    names or logos mentioned in our Site are the property of
                    their respective owners.
                  </p>
                  <h3>Use of the Site</h3>
                  <ul>
                    <li>
                      You are granted a personal, limited, non-sublicensable
                      license to access and use the Site and electronically
                      copy, and print to hard copy portions of the Site
                      materials for your informational, non-commercial and
                      personal use only.
                    </li>
                    <li>
                      Such license does not include: (a) any resale or
                      commercial use of our Site or the Site materials therein;
                      (b) the collection and use of any product listings,
                      pictures or descriptions for commercial purposes; (c) the
                      distribution, public performance or public display of any
                      Site materials, (d) modifying or otherwise making any
                      derivative uses of our Site and the Site materials, or any
                      portion thereof; (e) use of any automated means to access,
                      monitor or interact with any portion of our Site,
                      including through data mining, robots, spiders, scraping,
                      or similar data gathering or extraction methods; (f)
                      downloading (other than the page caching) of any portion
                      of our Site, the Site materials or any information
                      contained therein, except as expressly permitted on our
                      Site; (g) cause to appear any pop-up, pop-under, exit
                      windows, expanding buttons, banners, advertisement, or
                      anything else which minimizes, covers, or frames or
                      inhibits the full display of our Site; (h) use our web
                      sites in any way which interferes with the normal
                      operation of our sites; or (i) any use of our Site or the
                      Site materials other than for its intended purpose.
                    </li>
                    <li>
                      Any use of our Site or the Site materials other than as
                      specifically authorized herein, without the prior written
                      permission of Greenrock Creations, is strictly prohibited
                      and will terminate the license granted herein. Such
                      unauthorized use may also violate applicable laws,
                      including without limitation copyright and trademark laws
                      and applicable communications regulations and statutes.
                      Unless explicitly stated herein, nothing in these
                      Conditions shall be construed as conferring any license to
                      intellectual property rights, whether by estoppel,
                      implication, or otherwise. This license is revocable at
                      any time.
                    </li>
                  </ul>
                  <h3>Information on our website</h3>
                  <p>
                    Greenrock Creations is committed to providing current and
                    accurate information on our web sites, email, chat, and
                    telephone communications. We do not, however, warrant that
                    this information is always correct, accurate or complete. In
                    rare circumstances, data, including prices, may be
                    inaccurately displayed on our Site due to system and
                    typographical errors which may occur. Inadvertent errors or
                    inaccurate advertised prices are not binding on Greenrock
                    Creations, and may be adjusted by Greenrock Creations at any
                    time. Greenrock Creations reserves the right to correct any
                    and all errors when they do occur. If an order is placed
                    with a lower product's listed price than the actual price,
                    Greenrock Creations will, at its discretion, either advise
                    the customer before shipping the product or cancel the order
                    and notify the customer of such cancellation. Greenrock
                    Creations apologizes for any inconvenience that this may
                    cause.
                  </p>
                  <p>
                    Information that we communicate is not a binding contract,
                    and should not be treated as such. The sole remedy of a
                    customer acting on incorrect information is to request a
                    cancellation of the order placed as a result of this
                    incorrect information. If an order has been shipped, the
                    customer agrees to either return the product for full credit
                    or pay the difference between the actual and charged prices.
                    Please review our Return Policies.
                  </p>
                  <p>
                    Greenrock Creations' product details and prices are also
                    subject to change without notice. All of our prices are
                    final and non-negotiable. Additionally, in order to conserve
                    natural resources, and maintain the high quality of our
                    pieces, Greenrock Creations does not allow multiple pieces
                    to be purchased for comparison, which is the act of buying
                    several items with the intent of keeping the item that you
                    like best and returning the remaining items that were
                    purchased. If you have any questions regarding our policy,
                    please contact our Customer Service at
                    info@greenrockcreations.com.
                  </p>
                  <p>
                    All representations including representations regarding
                    gemstone origin, recycled content of precious metals, and
                    estate information, are provided to the best of Greenrock
                    Creations' knowledge and without guarantee or warranty of
                    any kind.
                  </p>
                  <h3>Your account and order</h3>
                  <p>
                    When you access or use the Greenrock Creations website or
                    your personalized Greenrock Creations account, you are
                    solely responsible for maintaining the confidentiality of
                    your account and for restricting access to your computer.
                    You are further responsible for all activities that occur
                    under your personal account and your password. If you are
                    under the age of 18 years old, you may use our only under
                    the guidance and direction of a parent or guardian. Please
                    note that Greenrock Creations reserves the right, in its
                    sole discretion, to refuse service, terminate accounts,
                    remove or edit content or cancel orders.
                  </p>
                  <p>
                    In the case where a customer files a chargeback, Greenrock
                    Creations has the right to recover its direct and indirect
                    costs, and cancel any promotional items, free shipping, or
                    other benefits, as determined in Greenrock Creations' sole
                    and absolute discretion.
                  </p>
                  <h3>Certificate of Authenticity</h3>
                  <p>
                    When you order a loose gemstone or jewelry piece, Greenrock
                    Creations will ship it to you with the accompanying
                    certificate of authenticity or grading report, if
                    applicable. These grading reports are detailed documents
                    created by experts at highly-respected laboratories. These
                    grading reports are extremely expensive to replace and as a
                    result of this, Greenrock Creations requires each grading
                    report to be included with each returned item. If you do not
                    include the grading report with your return, you will be
                    charged a replacement fee.
                  </p>
                  <h3>Passage of Title</h3>
                  <p>
                    Title for goods purchased passes from Greenrock Creations to
                    the purchaser's designee at the time that goods are
                    delivered to the designee.
                  </p>
                  <h3>Signature Requirement</h3>
                  <p>
                    For your protection, Greenrock Creations may require a
                    signature upon delivery of your order.
                  </p>
                  <h3>Disclaimer of Warranties</h3>
                  <p>
                    THIS SITE, THE CONTENT CONTAINED THEREIN AND THE PRODUCTS
                    PROVIDED IN CONNECTION THEREWITH (THE "PRODUCTS") ARE
                    PROVIDED ON AN 'AS IS' AND 'AS AVAILABLE' BASIS. GREENROCK
                    CREATIONS MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY
                    KIND, WHETHER EXPRESS OR IMPLIED, AS TO THE OPERATION OF
                    THIS SITE OR THE INFORMATION, CONTENT, MATERIALS OR PRODUCTS
                    INCLUDED ON IT. YOU EXPRESSLY AGREE THAT YOUR USE OF THIS
                    SITE IS AT YOUR SOLE RISK, BY YOUR OWN FREE WILL, AND THAT
                    YOU ARE SOLELY RESPONSIBLE FOR ANY CONSEQUENCES ARISING FROM
                    THIS USE. WITHOUT LIMITING THE FOREGOING, GREENROCK
                    CREATIONS DISCLAIMS ALL WARRANTIES, WHETHER EXPRESSED OR
                    IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES
                    OF MERCHANTABILITY AND/OR FITNESS FOR A PARTICULAR PURPOSE,
                    TITLE, AND NON-INFRINGEMENT AS TO THE INFORMATION, CONTENT,
                    AND MATERIALS ON THE SITE. GREENROCK CREATIONS DOES NOT
                    WARRANT THAT THIS SITE, ITS SERVERS, OR ITS ELECTRONIC
                    COMMUNICATION ARE ACCURATE, RELIABLE, COMPLETE, CURRENT OR
                    FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
                  </p>
                  <h3>Limitation of Liability</h3>
                  <p>
                    IN NO EVENT SHALL GREENROCK CREATIONS, ITS DIRECTORS,
                    MEMBERS, EMPLOYEES, AFFILIATES, OR AGENTS OR ANY OTHER PARTY
                    INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE GREENROCK
                    CREATIONS PRODUCTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR
                    DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS SITE,
                    INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL,
                    SPECIAL, PUNITIVE AND CONSEQUENTIAL DAMAGES OR OTHER DAMAGES
                    OF ANY KIND, INCLUDING BUT NOT LIMITED TO LOSS OF USE, LOSS
                    OF PROFITS, OR LOSS OF DATA, WHETHER IN CONTRACT, TORT, OR
                    OTHERWISE, INCLUDING NEGLIGENCE, ARISING OUT OF OR IN ANY
                    WAY CONNECTED WITH OR RESULTING FROM THE USE OF OUR SITE,
                    THE PRODUCTS, THE SERVICES OR THE CONTENT CONTAINED IN OR
                    ACCESSED THROUGH THE GREENROCK CREATIONS SITE, OR THAT
                    RESULTS FROM THE RELIANCE BY USER ON ANY INFORMATION
                    OBTAINED FROM GREENROCK CREATIONS, INCLUDING ANY ERROR OR
                    OMISSION REGARDING LISTED GEMSTONE ORIGIN, ANY MISTAKES,
                    OMISSIONS, INTERRUPTIONS, DELETION OF FILES OR EMAILS,
                    ERRORS, DEFECTS, VIRUSES, DELAYS IN OPERATION OR
                    TRANSMISSION OR ANY FAILURE OF PERFORMANCE OF THE GREENROCK
                    CREATIONS SITE, WHETHER OR NOT RESULTING FROM ACTS OF GOD,
                    COMMUNICATIONS FAILURE, THEFT, DESTRUCTION OR UNAUTHORIZED
                    ACCESS TO GREENROCK CREATIONS' PROGRAMS OR SERVICES, EVEN IF
                    GREENROCK CREATIONS IS EXPRESSLY ADVISED OF THE POSSIBILITY
                    OF SUCH DAMAGES, OR EVEN IF THE LOSS, DAMAGE OR EXPENSE WAS
                    CAUSED BY GREENROCK CREATIONS, ITS DIRECTORS, MEMBERS,
                    EMPLOYEES, AFFILIATES OR AGENTS. IN NO EVENT SHALL GREENROCK
                    CREATIONS' LIABILITY BE GREATER THAN THE PRICE YOU PAID FOR
                    THE PRODUCT OR SERVICE THAT IS THE BASIS FOR THE CLAIM.
                  </p>
                  <p>
                    Some jurisdictions may not allow the exclusion of implied
                    warranties, so some of the above exclusions may not apply to
                    you. It is your responsibility to check local laws for any
                    restrictions or limitations regarding the exclusions of
                    implied warranties.
                  </p>
                  <h3>Indemnification</h3>
                  <p>
                    You agree to defend, indemnify, and hold harmless Greenrock
                    Creations, its independent contractors, service providers
                    and consultants, and its parents, affiliates, and related
                    entities and their respective directors, officers,
                    employees, and agents from and against all claims, losses,
                    damages, liabilities, expenses and costs (including without
                    limitation reasonable attorneys' fees and court costs),
                    arising out of or relating to your breach of these
                    Conditions or your access to or use of the Greenrock
                    Creations Site or inability to use the Site, including
                    without limitation any actual or threatened suit, demand or
                    claim made against Greenrock Creations and/or its
                    independent contractors, service providers, employees,
                    directors or consultants, arising out of or relating to the
                    Content, your conduct, your violation of these Terms and
                    Conditions or your violation of the rights of any third
                    party.
                  </p>
                  <h3>Links to other sites and services</h3>
                  <p>
                    Links to other Internet sites and services operated by third
                    parties, including Greenrock Creations vendors, do not
                    constitute sponsorship, endorsement, or approval by
                    Greenrock Creations of the content, policies, or practices
                    of such linked sites or services. Greenrock Creations is not
                    responsible for the availability, content, security,
                    policies, or practices of linked sites or services,
                    including, without limitation, the accuracy of content on
                    linked sites or services and the privacy policies and
                    practices of linked sites and services.
                  </p>
                  <h3>Termination</h3>
                  <p>
                    Notwithstanding any of these Conditions, Greenrock Creations
                    reserves the right, without notice and in its sole
                    discretion, to terminate your license to use this site, and
                    to block or prevent your future access to and use of the
                    Site.
                  </p>
                  <h3>Miscellaneous</h3>
                  <p>
                    These Conditions contain the entire understanding of you and
                    Greenrock Creations with respect to the subject matter
                    hereof and supersede all prior agreements and understandings
                    between you and Greenrock Creations with respect to the
                    subject matter hereof. The failure of Greenrock Creations at
                    any time to enforce any of the provisions of these
                    Conditions will not be deemed or construed to be a waiver of
                    any such provisions, or in any way to affect the right of
                    Greenrock Creations to thereafter enforce each and every
                    provision of these Conditions. No waiver by Greenrock
                    Creations of any breach of any provision of these Conditions
                    will be construed or deemed to be a waiver of any other
                    subsequent breach. If any provision of these Conditions is
                    declared invalid or otherwise determined to be unenforceable
                    for any reason, such provision will be deemed to be
                    severable from the remaining provisions of these Conditions,
                    which will otherwise remain in full force and effect.
                    Provisions concerning your rights and obligations which by
                    the content of the provision operate after termination or
                    which are necessary to enforce any right will survive any
                    termination or expiration of these Conditions.
                  </p>
                  <h3>Arbitration</h3>
                  <p>
                    These Conditions and your use of this Site shall be governed
                    by and construed in accordance with the laws of the State of
                    [Your State], without resort to its conflict of law
                    provisions. You agree that any action at law or in equity or
                    any dispute, claim or controversy arising out of or relating
                    to these Conditions or the breach, termination, enforcement,
                    interpretation or validity thereof or the use of the Site or
                    purchases from the Site thereof, (collectively, "Claims")
                    shall be resolved by binding arbitration, as described
                    below, instead of in court, except that each party retains
                    the right to bring an individual action in small claims
                    court. You further agree that arbitration must be on an
                    individual basis and that you are hereby waiving your right
                    to join or consolidate Claims in arbitration or arbitrate
                    any claims as a representative or member of a purported
                    class. You acknowledge and agree that you are waiving the
                    right to a trial by jury. This arbitration provision shall
                    survive the termination of these Conditions, as well as any
                    other contractual agreement that you have with the Company.
                  </p>
                  <p>
                    You acknowledge and agree that, by agreeing to these
                    Conditions, the Federal Arbitration Act ("FAA") shall govern
                    the interpretation and enforcement of this provision and
                    that any such arbitration must proceed with the American
                    Arbitration Association ("AAA") or JAMS in [Your County,
                    State], before a mutually agreed upon single arbitrator
                    licensed to practice law. It will be conducted in accordance
                    with the then-prevailing Arbitration Rules of the AAA and
                    the arbitrator shall be bound by these Conditions. The
                    arbitrator shall have authority to award or grant legal,
                    equitable, and declaratory relief. Such arbitration shall be
                    final and binding on the parties.
                  </p>
                  <h3>Questions</h3>
                  <p>
                    If you have any questions, please do not hesitate to contact
                    us at info@greenrockcreations.com.
                  </p>
                </div>
                <div className="form-group checkbox-group">
                  <input
                    className="form-checkbox"
                    type="checkbox"
                    id="isAcceptPolicy"
                    {...register("isAcceptPolicy", {
                      required: "You must accept the policy",
                    })}
                  />
                  <label htmlFor="isAcceptPolicy">
                    I accept the{" "}
                    <a
                      href="/terms-and-condition"
                      style={{
                        color: "#97602d",
                        textDecoration: "underline",
                        fontWeight: 600,
                      }}
                    >
                      Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href="/privacy-policy"
                      style={{
                        color: "#97602d",
                        textDecoration: "underline",
                        fontWeight: 600,
                      }}
                    >
                      Privacy Policy
                    </a>
                    *
                  </label>
                  {errors.isAcceptPolicy && (
                    <span className="error-message">
                      {errors.isAcceptPolicy.message}
                    </span>
                  )}
                </div>
              </div>
            )}
            <div
              className={`d-flex ${
                compatedStep >= 2
                  ? "justify-content-between"
                  : "justify-content-end"
              }`}
            >
              {compatedStep >= 2 && (
                <button
                  type="button"
                  className="submit-button"
                  onClick={handlePrevious}
                >
                  Previous
                </button>
              )}
              <button type="submit" className="submit-button">
                {compatedStep === 3 ? "Submit" : "Next"}{" "}
                {registrationInProgress && <InlineLoaderComponent />}
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Signup;
